import { Draggable } from "@hello-pangea/dnd";
import { RequestDealerModel } from "../../../domain/models/dealerModel";
import LicensePlate from "license-plate";
import licencePlateSelectBg from "../../../../../general/fields/modules/commons/licencePlateSelectField/assets/licencePlateSelectBg.svg";
import { GripVertical } from "react-bootstrap-icons";
import ReactDOM from "react-dom";

export const RouteDraggableRequest = ({
  request,
  index,
  portal,
}: {
  request: RequestDealerModel;
  index: number;
  portal: HTMLDivElement;
}) => {
  return (
    <Draggable
      key={"request:" + request.id}
      draggableId={"request:" + request.id}
      index={index}
    >
      {(provided, snapshot) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const plate = new LicensePlate(request.source?.car?.licence ?? "");
        const child = (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            {plate.valid() ? (
              <div
                className={"planning-licence-plate me-2 mt-2"}
                key={request.id}
                style={{
                  background: `url(${licencePlateSelectBg}) no-repeat center center / cover`,
                }}
              >
                <div>{plate.pretty()}</div>
                <GripVertical
                  color={"white"}
                  width={15}
                  height={20}
                  className={"planning-licence-plate-icon"}
                />
              </div>
            ) : (
              <div>
                <GripVertical
                  color={"black"}
                  width={15}
                  height={20}
                  className={"planning-licence-plate-icon"}
                />
                {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  //@ts-ignore
                  request.source?.car?.licence ?? request.source?.car?.label
                }
              </div>
            )}
          </div>
        );

        if (!snapshot.isDragging) {
          return child;
        }

        return ReactDOM.createPortal(child, portal);
      }}
    </Draggable>
  );
};
